import React, { Component } from "react";
import Header from "../../Header/Header";
import Profile from "./Profile";
import Withdraws from "./Withdraws";
import Order from "./Order";
import Wallet from "./Wallet";
import Changepassword from "./Changepassword";
import Transaction from './TransactionNew';
import { withTranslation } from 'react-i18next';
import { history } from "../../helpers/history";
import { connect } from 'react-redux';
import MyFavourite from "./MyFavourite";
import BalanceDetails from "./BalanceDetails";
import { gameActions } from "../../action/GameAction";
import HomeSlidTabs from "../Home/HomeSlidTabs";
import KycStatus from "./KycStatus";
import KycUpdate from "./KycUpdate";
import JackpotWinner from "./JackpotWinner";
import MyFavouriteNew from "./MyFavouriteNew";
import Refferal from "./Refferal";
import FreeSpinTab from "./FreeSpinTab";
import Footer from "../../Footer/Footer";
import CryptoJS from 'crypto-js';

class Account extends Component {
    constructor(props) {
        super(props);
        const tabid = localStorage.getItem('atabId') ? localStorage.getItem('atabId') : 1;
        // if (tabid == null || tabid == "")
        this.state = {
            setTabID: (tabid == null || tabid == "") ? 1 : tabid,
            PageContol: 1,
            lastlogindate: new Date(localStorage.getItem('lastloginuserdate')),
            ProfileMulti: 0,
            OpenJackpot: false,
            SelectBonusObj: {}

        }
        //only allow logged in users
        if (!props.user || props.user.mobileNo == "0") {
            history.push('/login');
        }
        // if (!this.props.Amtrestnotes) {
        this.props.Amountrestriction(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
        // }
    }

    changeTab = (tabId) => {
        this.setState({ PageContol: 1 })
        this.setState({ OpenJackpot: false })
        this.setState({ ProfileMulti: 0 })
        localStorage.setItem('atabId', tabId);
        this.setState({ setTabID: tabId });
    }

    changeEvt = (evt) => {
        this.changeTab(evt.target.value);
    }

    UpdateFlag = (flag) => {
        this.setState({ PageContol: flag })
    }

    UpdateKycControl = (value) => {
        this.setState({ ProfileMulti: value })
    }

    UpdateJackpotFlag = () => {
        this.setState({ OpenJackpot: !this.state.OpenJackpot })
    }

    GetSelectBonus = (Obj) => {
        this.setState({ SelectBonusObj: Obj })
        this.resetPGURL(Obj.bonus_id)
    }

    componentDidMount() {
        if (this.props.location) {
            const query = new URLSearchParams(this.props.location.search);
            const token = query && query.get('pn')
            if (token) {
                const token1 = CryptoJS.AES.decrypt(token.replaceAll("@", "+").replaceAll(" ", "+"), "U2FsdGVkX1/dTA00hg0swnksKTyUdhPWxhPpY1CEqEs=").toString(CryptoJS.enc.Utf8);
                const ft = token1.split("~");
                if (ft && ft.length > 1) {
                    let gotcartflog = localStorage.getItem('isRedirectToCart');
                    if (gotcartflog == 1) {
                        localStorage.removeItem('isRedirectToCart');
                        setTimeout(() => {
                            history.push('/payment');
                        }, 500);
                    }
                }
            }
        }
    }


    render() {
        const { t } = this.props;
        let parts = []
        if (this.state.lastlogindate) {
            parts = this.state.lastlogindate.toString().split(" ");
        }
        return (
            <>
                <Header />
                <div class="container">
                    <HomeSlidTabs />
                    <div class="rht bg2 content">
                        <div class="bredCrums">
                            <ul>
                                <li><a onClick={() => { history.push('/') }}> {t('lblHome')} <img src="./assets/img/icons/right-angle.png" /></a></li>
                                <li><a class="active"> {t('lblMyAccount')}</a></li>
                            </ul>
                        </div>
                        <div class="myAccount">
                            <div class="profileName">
                                <div class="profileNameCont">
                                    <div class="firstLetterCont">
                                        <div class="firstLetterTxt">{this.props.user.Player_name && this.props.user.Player_name.length > 0 ?
                                            <>{this.props.user.Player_name.charAt(0).toUpperCase()}</> : <p>?</p>
                                        }</div>
                                    </div>
                                    <div class="nameAndDetails">
                                        <h2>{this.props.user.Player_name}</h2>
                                        {parts && parts.length > 4 && <p><img src="./assets/img/icons/clock.png" />{t('lbllastlogin')}: {parts[2]} {parts[1]} {parts[3]} {parts[4]}</p>}
                                    </div>
                                </div>
                                <div class="statusCont">
                                    <div class="statusTxt">{t('lblStatus')} :</div>
                                    <div class="statusNow"><img src="./assets/img/icons/status-active.png" />{t('lblactive')}</div>
                                </div>
                            </div>
                            <div class="myAccTabs">
                                <ul>
                                    <li onClick={() => this.changeTab(1)} ><a className={this.state.setTabID == 1 ? "active" : ""} ><img src="./assets/img/icons/tabs-profile.png" />{t('lblProfile')}</a></li>
                                    <li onClick={() => this.changeTab(2)} ><a className={this.state.setTabID == 2 ? "active" : ""}><img src="./assets/img/icons/tabs-orders.png" />{t('lblOrders')}</a></li>
                                    <li onClick={() => this.changeTab(3)} ><a className={this.state.setTabID == 3 ? "active" : ""}><img src="./assets/img/icons/tabs-wallet.png" />{t('lblWallet')}</a></li>
                                    <li onClick={() => this.changeTab(4)} ><a className={this.state.setTabID == 4 ? "active" : ""}><img src="./assets/img/icons/tabs-withdrawals.png" />{t('lblwithdrawls')}</a></li>
                                    <li onClick={() => this.changeTab(7)} ><a className={this.state.setTabID == 7 ? "active" : ""}><img src="./assets/img/icons/tabs-favourites.png" />{t('lblFav')}</a></li>
                                    <li onClick={() => this.changeTab(6)} ><a className={this.state.setTabID == 6 ? "active" : ""}><img src="./assets/img/icons/tabs-transactions.png" />{t('lblTransaction')}</a></li>
                                    <li onClick={() => this.changeTab(8)} ><a className={this.state.setTabID == 8 ? "active" : ""}><img src="./assets/img/icons/tabs-referral.png" />Referral</a></li>
                                </ul>
                                <div class="myAccCont">
                                    {this.state.setTabID == 1 && this.state.ProfileMulti == 0 && <><KycStatus kyccontrolfunc={(value) => { this.UpdateKycControl(value) }} /> <Profile /></>}
                                    {this.state.setTabID == 2 && <Order />}
                                    {this.state.setTabID == 4 && <Withdraws />}
                                    {this.state.setTabID == 1 && this.state.ProfileMulti == 1 && <KycUpdate kyccontrolfunc={(value) => { this.UpdateKycControl(value) }} />}
                                    {this.state.setTabID == 1 && this.state.ProfileMulti == 2 && <Changepassword kyccontrolfunc={(value) => { this.UpdateKycControl(value) }} />}
                                    {this.state.setTabID == 6 && this.state.OpenJackpot == true && <JackpotWinner />}
                                    {this.state.setTabID == 7 && <MyFavouriteNew />}
                                    {this.state.setTabID == 6 && this.state.OpenJackpot == false && <Transaction UpdateJackpotFlag={this.UpdateJackpotFlag} />}
                                    {this.state.setTabID == 8 && <Refferal />}
                                    {/* 1 = separateBalanceShow,2=Wallet,3=freespin Tab,4=View Bonus details, */}
                                    {this.state.setTabID == 3 && this.state.PageContol == 1 && <BalanceDetails changeFlag={(flag) => (this.UpdateFlag(flag))} />}
                                    {this.state.setTabID == 3 && this.state.PageContol == 2 && <Wallet SelectBonusObj={this.state.SelectBonusObj} locationData={this.props.location} changeTab={this.changeTab} changeFlag={(flag) => (this.UpdateFlag(flag))} />}
                                    {this.state.setTabID == 3 && this.state.PageContol == 3 && <FreeSpinTab changeFlag={(flag) => (this.UpdateFlag(flag))} />}
                                </div>
                                <Footer />
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="wrap2">
                    <div className="profile profileTopMargin">
                        <ul className="profileTabs">
                            <li className={(this.state.setTabID == 1) ? "proTabItem1 tabActive" : "proTabItem1"}><a className="proLiPos1" onClick={() => this.changeTab(1)}>{t('lblProfile')}</a></li>
                            <li className={(this.state.setTabID == 2) ? "proTabItem2 tabActive" : "proTabItem2"}><a className="proLiPos2" onClick={() => this.changeTab(2)}>{t('lblOrders')}</a></li>
                            <li className={(this.state.setTabID == 3) ? "proTabItem3 tabActive" : "proTabItem3"}><a className="proLiPos3" onClick={() => this.changeTab(3)}>{t('lblWallet')}</a></li>
                            <li className={(this.state.setTabID == 4) ? "proTabItem4 tabActive" : "proTabItem4"}><a className="proLiPos4" onClick={() => this.changeTab(4)}>{t('lblwithdrawls')}</a></li>
                            <li className={(this.state.setTabID == 5) ? "proTabItem5 tabActive" : "proTabItem5"}><a className="proLiPos5" onClick={() => this.changeTab(5)}>{t('lblChangepPwd')}</a></li>
                            <li className={(this.state.setTabID == 7) ? "proTabItem6 tabActive" : "proTabItem6"}><a className="proLiPos6" onClick={() => this.changeTab(7)}>{t('lblFav')}</a></li>
                            <li className={(this.state.setTabID == 6) ? "proTabItem7 tabActive" : "proTabItem7"}><a className="proLiPos7" onClick={() => this.changeTab(6)}>{t('lblTransaction')}</a></li>
                        </ul>
                        <select name="user-menu" className="pUserMenuMobile" onChange={(e) => this.changeEvt(e)} value={this.state.setTabID}>
                            <option value='1' >{t('lblProfile')}</option>
                            <option value='2' >{t('lblOrders')}</option>
                            <option value='3' >{t('lblWallet')}</option>
                            <option value='4' >{t('lblwithdrawls')}</option>
                            <option value='5'>{t('lblChangepPwd')}</option>
                            <option value='6' >{t('lblTransaction')}</option>
                            <option value='8' >{t('lblPurchase')}</option>
                        </select>
                        {this.state.setTabID == 1 && <Profile />}
                        {this.state.setTabID == 2 && <Order />}
                        {this.state.setTabID == 3 && this.state.PageContol == false && <Wallet locationData={this.props.location} changeTab={this.changeTab} changeFlag={this.UpdateFlag} />}
                        {this.state.setTabID == 4 && <Withdraws />}
                        {this.state.setTabID == 5 && <Changepassword />}
                        {this.state.setTabID == 6 && <Transaction changeTab={this.changeTab} />}
                        {this.state.setTabID == 7 && <MyFavourite />}
                        {this.state.setTabID == 3 && this.state.PageContol == true && <BalanceDetails changeFlag={this.UpdateFlag} />}
                    </div>
                </div> */}
            </>
        )
    }
}
function mapStateToProps(state) {
    const { user } = state.loginReducer;
    const { Amtrestnotes } = state.gameReducer;
    return { user, Amtrestnotes };
}
const mapActionToProps = {
    Amountrestriction: gameActions.Amountrestriction
}
//export default withTranslation()(Account);
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Account))